// extracted by mini-css-extract-plugin
export default {"disableClick":"cdWhNk"};